module.exports = __webpack_public_path__ + "static/img/ludek_calm.2de7def4.png";